import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';

import { formatTraitDate } from '../../utils/traitDates.js';

/** A trait's history, oldest first, as the payload sends it: a date and what happened (CT-5715). */
const TraitHistory = memo(function TraitHistory({ history = [] }) {
  const { i18n } = useTranslation('unified-profiles');
  const language = i18n?.language;

  return (
    <ol className="flex flex-col gap-2">
      {history.map((entry) => (
        <li key={entry.id} className="flex gap-4 text-sm">
          <span className="w-16 shrink-0 text-content-muted">{formatTraitDate(entry.at, language)}</span>
          <span className="min-w-0 text-content">{entry.text}</span>
        </li>
      ))}
    </ol>
  );
});

export default TraitHistory;
